export default "__VITE_ASSET__B5Lv6vNN__"